export * from './styles';

const addons = (enabled = true) =>
    ({
        controls: { disable: !enabled },
        actions: { disable: !enabled },
        options: {
            showPanel: enabled,
        },
        backgrounds: {
            default: 'yat-dark',
        },
        layout: enabled ? 'centered' : 'fullscreen',
    }) as const;

export const STORYBOOK_DISABLE_ADDONS = addons(false);

export const STORYBOOK_ENABLE_ADDONS = addons(true);

export const STORYBOOK_PARAMS_EXAMPLES = { ...addons(false), layout: 'centered' };
